import { styled } from '@mui/system'
import { TTheme } from '@/core/theme'
import Typography from '@/ui/components/typography'

export const Container = styled('div')<{ theme?: TTheme }>`
    border-radius: 8px;
    height: 100%;

    .open-cases-card {
        height: 325px;
        padding-top: 10px;
    }
`

export const TabsContainer = styled('div')<{ theme?: TTheme }>`
    display: flex;
    align-items: start;
    border-bottom: 1px solid ${({ theme }) => theme?.colors.greys[200]};
    gap: 18px;
`

export const Tab = styled('button')<{ active?: boolean; theme?: TTheme }>`
    display: flex;
    align-items: center;
    gap: 8px;
    padding-bottom: 12px;
    color: ${({ active, theme }) =>
        active ? theme?.colors.primary[900] : theme?.colors.greys[600]};
    font-size: var(--font-size-m);
    border: none;
    background: none;
    border-bottom: 2px solid
        ${({ active, theme }) =>
            active ? theme?.colors.primary[900] : 'transparent'};
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
        color: ${({ theme }) => theme?.colors.primary[900]};
    }
`

export const TabCount = styled(Typography)<{ theme?: TTheme }>`
    color: ${({ theme }) => theme?.colors.greys[600]};
`

export const CasesList = styled('div')<{ theme?: TTheme }>`
    padding-top: 15px;
    padding-right: 15px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    overflow-y: auto;
    max-height: 245px;
    scrollbar-gutter: stable;

    &::-webkit-scrollbar {
        width: 6px;
        background: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background: ${({ theme }) => theme?.colors.greys[200]};
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
`

export const CaseItem = styled('div')<{
    severity: TCaseSeverity
    type: 'Incident' | 'ServiceRequest'
    theme?: TTheme
}>`
    padding: 15px 20px;
    border-radius: 8px;
    cursor: pointer;
    background: ${({ severity, type, theme }) => {
        if (type === 'Incident' && severity === 'critical') {
            return theme?.colors.semantic.caseLightRed
        }
        return theme?.colors?.semantic?.openCasesBackground
    }};
    border: 1px solid
        ${({ severity, type, theme }) => {
            if (type === 'Incident' && severity === 'critical') {
                return theme?.colors.semantic.caseLightRedBorder
            }
            return theme?.colors?.semantic?.openCasesBorder
        }};
`

export const CaseType = styled('div')<{
    theme?: TTheme
    type: 'Incident' | 'ServiceRequest'
}>`
    color: ${({ theme, type }) =>
        type === 'Incident'
            ? theme?.colors.semantic.openCasesTypeIncidentTextColor
            : theme?.colors.primary[900]};
    background: ${({ theme, type }) =>
        type === 'Incident'
            ? theme?.colors.semantic.openCasesTypeIncidentBackgroundColor
            : theme?.colors.semantic
                  .openCasesTypeServiceRequestBackgroundColor};
    font-size: var(--font-size-s);
    margin-bottom: 3px;
    width: fit-content;
    padding: 1px 8px;
    border-radius: 20px;
`

export const CaseTitle = styled(Typography)<{ theme?: TTheme }>`
    color: ${({ theme }) => theme?.colors.greys[800]};
    margin-bottom: 3px;
`

export const CaseMetadata = styled('div')<{ theme?: TTheme }>`
    display: flex;
    align-items: center;
    gap: 12px;
    color: ${({ theme }) => theme?.colors.greys[600]};
    font-size: var(--font-size-s);

    span:not(:last-child)::after {
        content: '•';
        margin-left: 9px;
        color: ${({ theme }) => theme?.colors.greys[600]};
    }

    .created-date {
        color: ${({ theme }) => theme?.colors.greys[600]};
    }

    .severity-text {
        color: ${({ theme }) => theme?.colors.greys[800]};
    }
`
export const StatusTag = styled('div')<{
    status: 'waiting' | 'in-progress' | 'completed'
    theme?: TTheme
}>`
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${({ theme }) => theme?.colors.primary[900]};

    &::after {
        content: '•';
        margin-left: 4px;
        color: ${({ theme }) => theme?.colors.greys[600]};
    }

    .capitalize {
        text-transform: capitalize;
    }
`

export const EmptyStateContainer = styled('div')<{ theme?: TTheme }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: 100%;
    margin-top: 60px;
    svg {
        color: ${({ theme }) => theme?.colors.greys[400]};
        margin-bottom: 10px;
    }
`

export const EmptyStateTitle = styled(Typography)<{ theme?: TTheme }>`
    color: ${({ theme }) => theme?.colors.greys[800]};
`

export const EmptyStateSubtitle = styled(Typography)<{ theme?: TTheme }>`
    color: ${({ theme }) => theme?.colors.greys[500]};
`

export const CustomTabsWrapper = styled('div')`
    .tab-label {
        margin-right: 2px;
    }

    .tab-list {
        gap: 18px;
    }

    .MuiTabs-indicator {
        display: none;
    }

    .Mui-selected {
        font-weight: 500;
    }

    .MuiTabs-root {
        border-bottom: none;
    }

    .MuiButtonBase-root {
        font-size: 1.6rem;
        line-height: 20px;
        display: block;

        :hover {
            cursor: pointer;
        }

        :not(:first-of-type) {
            &:before {
                font-family: var(--font-family-primary);
                font-weight: var(--font-weight-light);
            }
        }
    }

    p {
        font-size: var(--font-size-xs);
    }

    button {
        padding: 0;
        margin-right: 20px;
    }
`
